import { useState } from "react";
import { useSelector } from "react-redux";
import { selectEditMode } from "../../../../store/user/selector";
import { CloseButton, EditButton, SaveButton } from "../rich_text/Buttons";

export const useEditButton = (
    onSave: () => void,
    onCancel?: () => void,
    forceEditMode?: boolean
): [any, boolean] => {
    const editMode = useSelector(selectEditMode);
    const [edit, setEdit] = useState(false);
    if (!editMode && !forceEditMode) {
        return [<></>, false];
    }
    if (!edit) {
        return [
            <EditButton
                onClick={() => {
                    setEdit(true);
                }}
            />,
            edit,
        ];
    }
    return [
        <>
            <SaveButton
                onClick={() => {
                    onSave();
                    setEdit(false);
                }}
            />
            <CloseButton
                onClick={() => {
                    if (onCancel) {
                        onCancel();
                    }
                    setEdit(false);
                }}
            />
        </>,
        edit,
    ];
};
